export default __webpack_public_path__ + "static/media/teacher_dashboard_banner_vector.71385e5e.svg";